export interface SampleGame {
  name: string;
  pgn: string;
}

export const SAMPLES: SampleGame[] = [
  {
    name: "Légal Tuzağı (taktik mat)",
    pgn: `[Event "Légal Tuzağı"]
[Site "Paris"]
[Date "1750.??.??"]
[White "Légal de Kermeur"]
[Black "Saint-Brie"]
[Result "1-0"]

1. e4 e5 2. Nf3 d6 3. Bc4 Bg4 4. Nc3 g6 5. Nxe5 Bxd1 6. Bxf7+ Ke7 7. Nd5# 1-0`,
  },
  {
    name: "Kulüp oyunu (hatalı orta oyun)",
    pgn: `[Event "Kulüp Maçı"]
[Site "?"]
[Date "2026.07.10"]
[White "Deniz"]
[Black "Aras"]
[Result "1-0"]

1. e4 e5 2. Nf3 Nc6 3. Bc4 Nf6 4. d3 Bc5 5. O-O d6 6. c3 a6 7. Re1 O-O 8. Bg5 h6 9. Bh4 g5 10. Bg3 Nh5 11. Nxg5 Nxg3 12. Bxf7+ Rxf7 13. Nxf7 Kxf7 14. hxg3 Kg8 15. Qh5 Bd7 16. Nd2 d5 17. exd5 Ne7 18. Qf3 Nf5 19. Ne4 Qf6 20. Nxf6+ Kh8 1-0`,
  },
];
